import { httpClient } from "./BaseApi";

const GET_CLINICS_URL = "api/clinic/choose.json";
const GET_CLINIC_DEVICE_URL = "api/clinic/device/item.json";
const GET_CLINIC_CURRENCIES_URL = "api/clinic/currencies.json";

const ClinicApi = {
  getClinics: () => {
    const token = JSON.parse(localStorage.getItem("userToken"));
    return httpClient.get(GET_CLINICS_URL, {
      headers: { Authorization: `Bearer ${token?.access_token}` },
    });
  },
  deleteDevice: () => {
    const token = JSON.parse(localStorage.getItem("userToken"));

    return httpClient.delete(GET_CLINIC_DEVICE_URL, {
      headers: { Authorization: `Bearer ${token?.access_token}` },
    });
  },
  getCurrencies: () => httpClient.get(GET_CLINIC_CURRENCIES_URL),
};

export default ClinicApi;
